var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chevron-left_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M42.667 8.39c-5.282 11.676-9.824 20.118-15.92 23.864 0 0 .013 0 .028.015h-.029c6.03 3.682 10.5 12.002 15.665 23.516l-23.57-23.57z"
  })));
};
export { SvgChevronLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNDIuNjY2OCA4LjM4OTE2QzM3LjM4NSAyMC4wNjYyIDMyLjg0MzEgMjguNTA4MiAyNi43NDYxIDMyLjI1NDNDMjYuNzQ2MSAzMi4yNTQzIDI2Ljc2MDMgMzIuMjU0MyAyNi43NzQ2IDMyLjI2ODZMMjYuNzQ2MyAzMi4yNjg3QzMyLjc3NjUgMzUuOTUxNCAzNy4yNDY3IDQ0LjI3MDYgNDIuNDEwNiA1NS43ODQ5TDE4Ljg0MDggMzIuMjE1MUw0Mi42NjY4IDguMzg5MTZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";